import { CenterPivot } from "appworks/graphics/pixi/group";
import { Services } from "appworks/services/services";
import { TranslationsService } from "appworks/services/translations/translations-service";
import { Contract } from "appworks/utils/contracts/contract";
import { gameLayers } from "game-layers";
import { SlingoLadderComponent } from "slingo/components/slingo-ladder-component";
import { ApplyFowlPlayTextStyling } from "util/fowl-text-style";

export class FowlLadderComponent extends SlingoLadderComponent {
    public init(): void {
        super.init();

        // Apply styling to "x picks" text
        [
            this.layer.getText("text_4"),
            this.layer.getText("text_5"),
            this.layer.getText("text_7"),
            this.layer.getText("text_9"),
            this.layer.getText("text_12"),
        ].forEach(text => {
            if (text) {
                ApplyFowlPlayTextStyling(text);
            }
        });

        // Set "+x wilds" text values
        const wilds120 = this.layer.getText("text_8");
        if (wilds120) wilds120.text = Services.get(TranslationsService).get("plus_x_wilds_caps", { value: 120 });
        const wilds240 = this.layer.getText("text_10");
        if (wilds240) wilds240.text = Services.get(TranslationsService).get("plus_x_wilds_caps", { value: 240 });
    }

    protected setValue(level: number, playSound?: boolean, durationMs?: number): Contract<void> {
        // Hide info for surpassed levels in portrait
        // Also portrait roof tile highlights
        for (let i = 0; i <= SlingoLadderComponent.MAX_SLINGOS; i++) {
            const img = this.layer.getSprite("p_img_" + i);
            if (img) img.visible = i >= level;

            const tile = gameLayers.TicketMatrixBacking.getSprite("tile_" + i);
            if (tile) tile.visible = i === level;
        }

        // Arrow for portrait ladder
        const arrow = this.layer.getSprite("ladder_arrow");
        const targetPos = this.layer.getSprite("p_fill_" + level);
        if (arrow && targetPos) {
            CenterPivot(arrow).portrait.x = targetPos.portrait.getCenterPoint().x;
        }

        return super.setValue(level, playSound, durationMs);
    }
}
